const DownloadInvoice = ({ primary = '#4C0055', secondary = '#FC5F3A' }) => {
  return (
    <svg
      width="25"
      height="32"
      viewBox="0 0 25 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.1694 3.90169L21.0983 1.83063C19.9179 0.650125 18.3484 0 16.6789 0H3.75C1.68225 0 0 1.68225 0 3.75V28.25C0 30.3177 1.68225 32 3.75 32H21.25C23.3177 32 25 30.3177 25 28.25V8.32106C25 6.65162 24.3499 5.08212 23.1694 3.90169ZM21.4016 5.66944C21.9121 6.17994 22.2562 6.812 22.4092 7.5H18.75C18.0607 7.5 17.5 6.93925 17.5 6.25V2.59075C18.1881 2.74375 18.8201 3.08788 19.3306 3.59831L21.4016 5.66944ZM21.25 29.5H3.75C3.06075 29.5 2.5 28.9393 2.5 28.25V3.75C2.5 3.06075 3.06075 2.5 3.75 2.5H15V6.25C15 8.31775 16.6823 10 18.75 10H22.5V28.25C22.5 28.9393 21.9393 29.5 21.25 29.5Z"
        fill={primary}
      />
      <path
        d="M18.75 22H6.25C5.55963 22 5 22.5596 5 23.25C5 23.9404 5.55963 24.5 6.25 24.5H18.75C19.4404 24.5 20 23.9404 20 23.25C20 22.5596 19.4404 22 18.75 22Z"
        fill={primary}
      />
      <path
        d="M15.8839 14.8661C15.3957 14.3779 14.6042 14.3779 14.1161 14.8661L13.75 15.2323V11.25C13.75 10.5596 13.1904 10 12.5 10C11.8096 10 11.25 10.5596 11.25 11.25V15.2323L10.8839 14.8661C10.3957 14.3779 9.60424 14.3779 9.11612 14.8661C8.62799 15.3543 8.62793 16.1458 9.11612 16.6339L11.6161 19.1338C11.8408 19.3587 12.1627 19.5 12.5 19.5C12.8187 19.5 13.1459 19.372 13.3839 19.1338L15.8839 16.6339C16.3721 16.1458 16.3721 15.3542 15.8839 14.8661Z"
        fill={secondary}
      />
    </svg>
  );
};

export default DownloadInvoice;
